import { render, staticRenderFns } from "./member-tab-base.vue?vue&type=template&id=f69a5796&scoped=true";
import script from "./member-tab-base.vue?vue&type=script&lang=jsx";
export * from "./member-tab-base.vue?vue&type=script&lang=jsx";
import style0 from "./member-tab-base.vue?vue&type=style&index=0&id=f69a5796&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "f69a5796", null);
export default component.exports;